function hasPageStaticHeader() {
  return Boolean(document.querySelector('ws-header[mode="static"]'));
}

export default hasPageStaticHeader;
